import React, { useEffect } from 'react'
import styled from 'styled-components'
import { View, Text, TouchableOpacity, ImageBackground } from 'react-native'
import { Box, Heading } from 'native-base'
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons'
import GoogleStaticMap from '../utils/GoogleStaticMap'

const Card = styled(GoogleStaticMap)`
    height: 200px;
    width: 350px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    overflow: hidden;
`

const LatLongContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

const Address = styled(Heading)`
    color: white;
    font-size: 24px;
    margin-bottom: -10px;
    /* Add drop Shadow to text */
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
`

const LatLong = styled(Heading)`
    color: white;
    font-size: 14px;
    margin: 0;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
`

export const RecentCard = (props) => {
    return (
        <Card latitude={String(props.home.location.lat)} longitude={String(props.home.location.long)} zoom={15} size={{ width: 350, height: 200 }} scale={2} mapID={'6c85a0185f1d9110'} apiKey={'AIzaSyDVQfJW6YU5m0cqtJqpFafJ3RzvfursP8w'}>
            <Address>{props.home?.display_address}</Address>
            <LatLongContainer>
                <MaterialCommunityIcons name="map-marker" size={14} color="white" style={{ marginRight: 5 }} />
                <LatLong>
                    {Math.round(props.home.location?.lat * 100000) / 100000}, {Math.round(props.home.location?.long * 100000) / 100000}
                </LatLong>
            </LatLongContainer>
        </Card>
    )
}
